export const SAVE_BRANCH_TAB_STATE = 'SAVE_BRANCH_TAB_STATE';
export const RETRIEVE_BRANCH_TAB_STATE = 'RETRIEVE_BRANCH_TAB_STATE';
